import { Component, Inject, Input } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
@Component({
    templateUrl: './confirmation-modal.component.html',
    selector: 'confiramtion-modal',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false
})
export class ConfiramtionModalComponent {

    @Input() message = 'doYouWantToPerfomTheAction';

    constructor(
        @Inject(MAT_DIALOG_DATA) private dialogData: { quarter: number; },
        private dialogRef: MatDialogRef<ConfiramtionModalComponent>
    ){}

    close(val: string){
        this.dialogRef.close(val);
    }
}